export const Router = {
  SignIn: '/sign-in',
  SignUp: '/sign-up',
  Home: '/',
  Search: '/search',
  Notifications: '/notifications',
  Me: '/me',
  ProfilePage: '/profile',
};
